<template>
  <v-container class="settings">
        <v-layout row wrap>
            <v-flex xs12 lg8 offset-lg2>

                <v-card>
                    <v-card-title>
                        <h3 class="headline">E-Mail-Benachrichtigungen</h3>
                    </v-card-title>
                    <v-card-text>
                      <div>
                          <v-switch v-model="$store.state.user.data.has_newsletter_contract" :value="$store.state.user.data.has_newsletter_contract==0" color="white" class="mt-0" @change="setNewsletterSetting" label="Vertragsspezifisch: Gibt es Neuigkeiten bei VAPP zu Ihrem Vertrag, informieren wir Sie immer am selben Tag per E-Mail. Denn uns ist es wichtig, dass Sie genauso auf dem neuesten Stand sind, wie Ihre Versicherungen."></v-switch>
                          <v-switch v-model="$store.state.user.data.has_newsletter_marketing" :value="$store.state.user.data.has_newsletter_marketing==0" color="white" @change="setNewsletterSetting" label="Allgemein: Wir informieren Sie, wenn es für Ihre Branche relevante Informationen oder Angebote gibt. Keine Sorge wir senden diese maximal einmal im Monat." style="margin:0"></v-switch>
                      </div>
                    </v-card-text>
                </v-card>

                <v-card class="authdata mt-4">
                    <v-card-title>
                        <h3 class="headline">Anmeldedaten für VAPP ändern</h3>
                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap justify-center>
                            <v-flex xs12>
                                <p>Sie können jederzeit Ihre E-Mail Adresse oder Ihr Passwort hier ändern. Für die Anmeldung bei VAPP und die E-Mail-Benachrichtigungen gelten die unten gespeicherten Angaben.</p>
                            </v-flex>
                            <v-flex xs12>
                                <small>E-Mail-Adresse</small>
                                <v-input messages="E-Mail-Adresse zur Anmeldung und zum Versand von Nachrichten" prepend-icon="mail_outline">
                                    {{ $store.state.auth.fb.email }}
                                    <template slot="append">
                                        <v-bottom-sheet v-model="show_form_email" lazy inset>
                                            <template v-slot:activator>
                                                <v-btn icon>
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card class="pa-3" tile>
                                                <v-form v-model="form_email" lazy-validation @submit.prevent="submit('form_email')">
                                                    <v-layout row wrap justify-center>
                                                        <v-flex xs12 px-2>
                                                            <v-text-field
                                                              v-model="$store.state.auth.fb.email"
                                                              type="email"
                                                              maxlength="120"
                                                              :rules="[rules.required, rules.email]"
                                                              label="E-Mail-Adresse *"
                                                              placeholder=""
                                                              clearable
                                                              required
                                                            />
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-card-actions class="pa-0">
                                                        <v-btn flat color="secondary" @click="show_form_email = false">Abbrechen</v-btn>
                                                        <v-spacer />
                                                        <v-btn color="black" dark @click="submit('form_email')">Speichern</v-btn>
                                                    </v-card-actions>
                                                </v-form>
                                            </v-card>
                                        </v-bottom-sheet>
                                    </template>
                                </v-input>
                            </v-flex>
                            <v-flex v-if="hasProvider('password')" xs12>
                                <v-divider class="my-2"></v-divider>
                                <small>Passwort</small>
                                <v-input messages="Passwort zur Anmeldung bei VAPP" prepend-icon="vpn_key">
                                    ••••••••••••
                                    <template slot="append">
                                        <v-bottom-sheet v-model="show_form_pass" lazy inset>
                                            <template v-slot:activator>
                                                <v-btn icon>
                                                    <v-icon>edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-card class="pa-3" tile>
                                                <v-form v-model="form_pass" lazy-validation @submit.prevent="submit('form_pass')">
                                                    <v-layout row wrap justify-center>
                                                        <v-flex xs12 sm6 px-2>
                                                            <v-text-field
                                                              v-model="pw_val1"
                                                              ref="password_1"
                                                              :append-icon="password_1 ? 'visibility_off' : 'visibility'"
                                                              :rules="[rules.min, rules.password]"
                                                              :type="password_1 ? 'text' : 'password'"
                                                              name="password_1"
                                                              label="Neues Passwort vergeben"
                                                              hint="Nur ausfüllen, wenn das Passwort geändert werden soll"
                                                              value=""
                                                              @click:append="password_1 = !password_1"
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 sm6 px-2>
                                                            <v-text-field
                                                              v-if="pw_val1.length>5"
                                                              v-model="pw_val2"
                                                              :append-icon="password_2 ? 'visibility_off' : 'visibility'"
                                                              :rules="[rules.min, rules.password, comparePasswords]"
                                                              :type="password_2 ? 'text' : 'password'"
                                                              name="password_2"
                                                              label="Passwort wiederholen"
                                                              hint="Bitte das Passwort genau wiederholen"
                                                              value=""
                                                              @click:append="password_2 = !password_2"
                                                            />
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-card-actions class="pa-0">
                                                        <v-btn flat color="secondary" @click="show_form_pass = false">Abbrechen</v-btn>
                                                        <v-spacer />
                                                        <v-btn color="black" dark @click="submit('form_pass')">Speichern</v-btn>
                                                    </v-card-actions>
                                                </v-form>
                                            </v-card>
                                        </v-bottom-sheet>
                                    </template>
                                </v-input>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>

                <v-card class="mt-4">
                    <v-card-title>
                        <h3 class="headline">Weitere Anmeldemethoden</h3>
                    </v-card-title>
                    <v-card-text>
                        <p>Wählen Sie hier andere Anmeldemethoden, wenn Sie sich zukünftig anders einloggen möchten:</p>
                        <v-layout row wrap justify-center>
                            <v-flex xs12 sm6>
                                <AuthProviderConnectButtons ref="AuthProviderConnectButtons" />
                            </v-flex>
                            <v-flex xs12 sm6 class="hiddencontent">
                                <span>ID: {{ $store.state.auth.fb.uid }}</span>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>

              <section class="text-xs-center mt-4 pt-4 white--text">
                  <div>Du möchtest zukünftig alles alleine machen? Kein Problem:</div>
                  <v-btn :ripple="{ class: 'red--text' }" flat @click="deleteUserModal = true" :loading="deletebtn_loader" class="white--text">Account löschen</v-btn>
              </section>


              <v-dialog v-model="deleteUserModal" absolute max-width="700">
                      <v-card>
                          <v-card-title class="headline">Sind Sie sich sicher?</v-card-title>
                          <v-card-text>
                              <p>Wenn Sie Ihren Account jetzt löschen werden sämtliche Daten von Ihnen unzugänglich gemacht und verloren sein. Sie müssen sich ab diesem Zeitpunkt selbst um alle Dokumente, Daten und Fragen kümmern. Wenn Sie Fragen haben, schreiben Sie uns einfach und wir helfen Ihnen weiter.</p>
                          </v-card-text>
                          <v-divider />
                          <v-card-actions>
                              <v-btn flat @click="deleteUserModal = false">Abbrechen</v-btn>
                              <v-spacer />
                              <v-btn color="red" dark @click="deleteUser">Account entgültig löschen</v-btn>
                          </v-card-actions>
                      </v-card>
              </v-dialog>

            </v-flex>
        </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/auth';
import AuthProviderConnectButtons from '@/components/AuthProviderConnectButtons'


export default {
    data: () => ({
        pw_val1: '',
        pw_val2: '',
        password_1: false,
        password_2: false,
        init_user_hasnewsletterstate: null,
        init_user_hasnewsletterstate_necessary: null,
        deletebtn_loader: false,
        deleteUserModal: false,
        show_form_email: false,
        form_email: true,
        show_form_pass: false,
        form_pass: true,
        rules: {
            required: value => !!value || 'Pflichtfeld - Bitte ausfüllen',
            min: v => { 
            if(v){ 
                if(v.length < 6){ 
                    return 'Geben Sie mindestens 6 Zeichen ein'; 
                }else{ 
                    return true;
                }
            }else{
                return true;
            }
            },
            email: v => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(v) || 'Bitte eine gültige E-Mail-Adresse eingeben'
            },
            password: v => {
                const pattern = /^(?=.*\d)(?=.*[A-Za-z])[0-9A-Za-z!?:_@#$%().=,-]{6,24}$/
                return (pattern.test(v) || v=='') || 'Bitte verwenden Sie Buchstaben und Zahlen für Ihr Passwort. Bei Bedarf können folgende Sonderzeichen verwendet werden: !?:_@#$%().=,'
            }
        }
    }),

    components: {
        AuthProviderConnectButtons
    },

    mounted () {
        if(this.$store.state.user.data.has_newsletter_marketing==1){
            this.init_user_hasnewsletterstate = this.$store.state.user.data.has_newsletter_marketing;
        }
        if(this.$store.state.user.data.has_newsletter_contract==1){
            this.init_user_hasnewsletterstate_necessary = this.$store.state.user.data.has_newsletter_contract;
        }
    },

    computed: {
        comparePasswords(){
            return this.pw_val1 !== this.pw_val2 ? 'Die Passwörter stimmen nicht überein' : true
        }
    },

    watch: {
        show_form_email: function(){
            if(!this.show_form_email){
                this.$store.state.auth.fb.email = this.$store.state.user.data.email;
            }
        },
        show_form_pass: function(){
            if(!this.show_form_pass){
                this.pw_val1 = '';
                this.pw_val2 = '';
            }
        }
    },

  methods: {
    setNewsletterSetting(){
        let helper_txt = '';
        let helper_var = '';
        if(this.init_user_hasnewsletterstate !== this.$store.state.user.data.has_newsletter_marketing){
            helper_txt = 'allgemeinen';
            helper_var = 'has_newsletter_marketing';
        }
        if(this.init_user_hasnewsletterstate_necessary !== this.$store.state.user.data.has_newsletter_contract){
            helper_txt = 'vertragsspezifischen';
            helper_var = 'has_newsletter_contract';
        }
        if(helper_txt !== '' && helper_var !== ''){
            this.$store.dispatch('user/setUserData', { has_newsletter_marketing: this.$store.state.user.data.has_newsletter_marketing, has_newsletter_contract: this.$store.state.user.data.has_newsletter_contract });
            let con = `Sie haben die ${helper_txt} E-Mail-Benachrichtigungen ausgeschaltet.`;
            let snotify_con = `Benachrichtigungen (${helper_txt}) ausgeschaltet`;
            if(this.$store.state.user.data[helper_var]){ 
                con = `Sie haben die ${helper_txt} E-Mail-Benachrichtigungen eingeschaltet.`; 
                snotify_con = `Benachrichtigungen (${helper_txt}) eingeschaltet`; 
            }
            this.$store.dispatch('chat/addUserChatMessage', {title:'E-Mail-Benachrichtigungen geändert', content:con, type: 'accountsettings'});
            this.init_user_hasnewsletterstate = this.$store.state.user.data.has_newsletter_marketing;
            this.init_user_hasnewsletterstate_necessary = this.$store.state.user.data.has_newsletter_contract;
            this.$snotify.success(snotify_con);
        }
    },

    submit (form_name) {
        var user = firebase.auth().currentUser;
        let newmail = this.$store.state.auth.fb.email;

        if(form_name=='form_email' && this.$store.state.user.data.email!=newmail){
            if(this.form_email){
                user.updateEmail(newmail).then(() => {
                    this.$store.dispatch('auth/sendEmailVerification', 'Ihre E-Mail-Änderung bestätigen').then(() => {
                        this.$store.state.user.data.email = newmail;
                        this.$store.state.auth.fb.emailVerified = false;
                        this.$store.dispatch('user/setUserData', this.$store.state.user.data);
                        this.$snotify.success('Bestätigungs-E-Mail wurde versendet');
                        this.$store.dispatch('chat/addUserChatMessage', {title:'E-Mail-Adresse geändert', content:'Sie haben in Ihren Anmeldeeinstellungen eine neue E-Mail-Adresse angegeben: '+newmail, type: 'accountsettings'});
                        this.show_form_email = false;
                    }).catch(error => {
                        console.error(error);
                        this.$snotify.error('Beim Versenden der Bestätigungs-Email ist ein Fehler aufgetreten. Bitte später manuell auslösen.');
                        this.show_form_email = false;
                    });
                }).catch(error => {
                    console.error(error);
                    if(error.code=='auth/email-already-in-use'){
                        this.$snotify.error('Die angegebene E-Mail-Adresse existiert bereits in einem anderen VAPP-Account', 'E-Mail-Adresse ungültig');
                    }else{
                        this.$snotify.error('Bitte melden Sie sich erneut an', 'Zulange inaktivität');
                        this.$store.dispatch('auth/logoutUser');
                    }
                    this.show_form_email = false;
                });
            }else{
                this.$snotify.warning('Überprüfen Sie Ihre Eingaben!');
            }
        }

        if(form_name=='form_pass' && (!_.isEmpty(this.pw_val1) && !_.isEmpty(this.pw_val2))){
            if(this.form_pass){
                if(this.hasProvider('password')){
                    user.updatePassword(this.pw_val1).then(() => {
                        this.$snotify.success('Passwort erfolgreich geändert');
                        this.$store.dispatch('chat/addUserChatMessage', {title:'Passwort geändert', content:'Sie haben Ihr Passwort zur Anmeldung mit E-Mail und Passwort geändert.', type: 'accountsettings'});
                    }).catch((error) => {
                        console.error('UNBEKANNTER PW-CHANGE-FEHLER:', error);
                        this.$snotify.error('Bitte melden Sie sich erneut an', 'Zulange inaktivität');
                        this.$store.dispatch('auth/logoutUser');
                    }).finally(() => {
                        this.show_form_pass = false;
                    });
                }else{
                    let credential = firebase.auth.EmailAuthProvider.credential(newmail, this.pw_val1);
                    user.linkWithCredential(credential).then(result => {
                        this.$store.dispatch('auth/setUserAuth', {user: result.user});
                    }).catch(error => {
                        console.error('UNBEKANNTER PROVIDER-MERGE-FEHLER (email):', error);
                        this.$snotify.error('Bitte melden Sie sich erneut an', 'Zulange inaktivität');
                    }).finally(() => {
                        this.show_form_pass = false;
                    });
                };
            }
        }
    },

    deleteUser(){
        this.deletebtn_loader = true;
        this.$store.dispatch('user/deleteClient').then(() => {
            this.deletebtn_loader = false;
            this.$snotify.success('Account erfolgreich entfernt');
            this.$store.dispatch('auth/logoutUser', `/account-geloescht`);
        }).catch(error => {
            this.deletebtn_loader = false;
            console.error('Fehler beim Löschen :>> ', error);
            this.$snotify.error('Bitte melden Sie sich erneut an', 'Zulange inaktivität');
            this.$store.dispatch('auth/logoutUser', `/login`);
        });
    },

    hasProvider(provider){
        return _.findIndex(this.$store.state.auth.fb.providerData, function(o) { return o.providerId == provider; }) < 0 ? false : true
    }
  }
}
</script>

<style scoped>
    small{
      padding-left: 32px;
    }

    @media screen and (max-width: 768px) {
        .pr-4, .pl-4, .pr-2, .pl-2, .px-2, .px-4{
            padding:0!important;
        }
        
    }
</style>
